"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function () { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function (o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function (o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function (o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o)
                if (Object.prototype.hasOwnProperty.call(o, k))
                    ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule)
            return mod;
        var result = {};
        if (mod != null)
            for (var k = ownKeys(mod), i = 0; i < k.length; i++)
                if (k[i] !== "default")
                    __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.TaskProductsTable = void 0;
const react_1 = __importStar(require("react"));
const graphql_1 = require("../../../../../__generated__/graphql");
const ui_components_1 = require("@groupby/ui-components");
const ramda_1 = require("ramda");
const react_redux_1 = require("react-redux");
const hooks_1 = require("./hooks");
const use_review_status_change_hook_1 = require("./hooks/use-review-status-change.hook");
const use_task_products_table_config_hook_1 = require("./hooks/use-task-products-table-config.hook");
const products_action_panel_1 = require("./products-action-panel");
const products_table_constants_1 = require("./products-table.constants");
const products_table_styles_1 = require("./products-table.styles");
const utils_1 = require("./utils");
const use_task_progress_hook_1 = require("../../client/hooks/use-task-progress.hook");
const column_configs_1 = require("../../column-configs");
const use_task_view_table_query_params_sync_1 = require("../../hooks/use-task-view-table-query-params-sync");
const client_constants_1 = require("../../../../client/client.constants");
const product_1 = require("../../../../client/product");
const product_table_1 = require("../../../../common/product-table");
const table_columns_1 = require("../../../../common/table-columns");
const table_filter_1 = require("../../../../common/table-filter");
const table_sort_1 = require("../../../../common/table-sort");
const use_table_loading_state_1 = require("../../../../common/use-table-loading-state");
const products_table_1 = require("../../../../components/products-table");
const attributes_1 = require("../../../../constants/attributes");
const product_table_dynamic_columns_1 = require("../../../../hooks/product-table-dynamic-columns");
const bulk_edit_product_attributes_dialog_1 = require("../../../../preview-products-widget/preview-products-widget-content/bulk-edit-product-attributes-dialog");
const hooks_2 = require("../../../../preview-products-widget/preview-products-widget-content/products-preview/products-list-view/hooks");
const products_customize_view_1 = require("../../../../preview-products-widget/preview-products-widget-content/products-preview/products-list-view/products-customize-view");
const product_details_dialog_component_1 = require("../../../../preview-products-widget/product-details-dialog/product-details-dialog.component");
const actions_1 = require("../../../../store/catalogs/task-view/actions");
const reducers_1 = require("../../../../store/catalogs/task-view/reducers");
const selectors_1 = require("../../../../store/catalogs/task-view/selectors");
const feature_flags_1 = require("../../../../../feature-flags");
const hooks_3 = require("../../../../../hooks");
const localization_1 = require("../../../../../localization");
const store_1 = require("../../../../../store");
const TaskProductsTable = ({ attributeName, productTreeNode, nodeTitle = '', }) => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const selectedCatalogId = (0, store_1.useSelectedCatalogId)();
    const { featureFlagsService } = (0, hooks_3.useFeatureFlagsService)();
    const enableMultiFiltering = featureFlagsService.isFeatureEnabled(feature_flags_1.FeatureFlag.MultiFiltering);
    const { addError, addSuccess } = (0, hooks_3.useNotification)();
    const { formatMessage: t } = (0, localization_1.useLocalization)();
    const [isBulkProductListRefreshing, setIsBulkProductListRefreshing] = (0, react_1.useState)(false);
    const tableSort = (0, selectors_1.useTaskViewProductsTableSortOrDefault)();
    const tableFilter = (0, selectors_1.useTaskViewProductsTableFilter)();
    const tableSearch = (0, selectors_1.useTaskViewProductsTableSearch)();
    const columnWidths = (0, selectors_1.useTaskViewProductsTableColumnWidth)();
    const tableRowSize = (0, selectors_1.useTaskViewProductsTableRowSize)();
    const selectedTreeNodePath = (0, selectors_1.useTaskViewProductsTableSelectedTreeNodePath)();
    const toggleRowSize = (0, react_1.useCallback)(() => dispatch((0, actions_1.setTaskViewTableRowSize)(selectedCatalogId, tableRowSize === ui_components_1.DataGridRowSize.Standard ? ui_components_1.DataGridRowSize.Adaptive : ui_components_1.DataGridRowSize.Standard)), [dispatch, selectedCatalogId, tableRowSize]);
    const [isCustomizeViewOpen, setIsCustomizeViewOpen] = (0, react_1.useState)(false);
    const [editInitialAttributeId, setEditInitialAttributeId] = (0, react_1.useState)(undefined);
    const attributeColumnId = (0, react_1.useMemo)(() => (0, table_columns_1.createColumnId)(attributeName, { isAIEnriched: true }), [attributeName]);
    const initialColumns = (0, react_1.useMemo)(() => [...products_table_constants_1.TASK_REVIEW_BASE_COLUMNS, attributeColumnId], [attributeColumnId]);
    const { persistedTableData, setPersistedTableData, hadStoredConfigOnLoad, } = (0, column_configs_1.useTaskViewColumnConfigsManager)();
    const onPinnedColumnsChange = (0, react_1.useCallback)((next) => {
        setPersistedTableData({ pinnedColumns: next });
    }, [setPersistedTableData]);
    const customizeTableColumnsReturnValue = (0, product_table_dynamic_columns_1.useCustomizeTableColumns)({
        initialColumns,
        options: {
            persisted: true,
            persistedTableData,
            setPersistedTableData,
        },
    });
    const { actions, reviewAttribute } = customizeTableColumnsReturnValue, dynamicTableColumns = __rest(customizeTableColumnsReturnValue, ["actions", "reviewAttribute"]);
    const tableQueryDynamicColumns = (0, react_1.useMemo)(() => ({
        columnsOrder: dynamicTableColumns.columnsOrder,
        pinnedColumns: persistedTableData.pinnedColumns,
        excludedColumns: dynamicTableColumns.excludedColumns,
        filterOptions: dynamicTableColumns.filterOptions,
        reviewAttribute,
        selectAllMode: dynamicTableColumns.selectAllMode,
    }), [
        dynamicTableColumns.columnsOrder,
        persistedTableData.pinnedColumns,
        dynamicTableColumns.excludedColumns,
        dynamicTableColumns.filterOptions,
        dynamicTableColumns.selectAllMode,
        reviewAttribute,
    ]);
    const handleHydrateDynamicColumns = (0, react_1.useCallback)((changes) => {
        actions.onChangeColumns(changes);
    }, [actions]);
    const areTaskViewQueryParamsReady = (0, use_task_view_table_query_params_sync_1.useTaskViewTableQueryParamsSync)({
        dynamicColumns: tableQueryDynamicColumns,
        onHydrateDynamicColumns: handleHydrateDynamicColumns,
    });
    const { onAddReviewAttributeColumn, } = (0, product_table_dynamic_columns_1.useReviewAttributeColumnManager)({
        defaultReviewAttributeIndex: products_table_constants_1.TASK_REVIEW_BASE_COLUMNS.length - 1, // before explanation column
        persistedData: dynamicTableColumns,
        setPersistedData: actions.onChangeColumns,
    });
    (0, react_1.useEffect)(() => {
        const defaultReviewAttributeIndex = products_table_constants_1.TASK_REVIEW_BASE_COLUMNS.length - 1;
        const currentAttributeColumnIndex = attributeColumnId
            ? dynamicTableColumns.columnsOrder.findIndex((id) => id === attributeColumnId)
            : -1;
        const isAtDefaultReviewAttributeIndex = currentAttributeColumnIndex === defaultReviewAttributeIndex;
        const isReviewAttributeAlreadySynced = Boolean(attributeColumnId
            && (reviewAttribute === null || reviewAttribute === void 0 ? void 0 : reviewAttribute.id) === attributeColumnId);
        if (!areTaskViewQueryParamsReady || !attributeColumnId) {
            return;
        }
        if (hadStoredConfigOnLoad) {
            if (isReviewAttributeAlreadySynced) {
                return;
            }
            if (currentAttributeColumnIndex >= 0) {
                // Column already exists in the persisted order. Sync reviewAttribute metadata only,
                // preserving the user-defined column order across refreshes.
                actions.onChangeColumns({
                    reviewAttribute: {
                        id: attributeColumnId,
                        previousIndex: currentAttributeColumnIndex,
                    },
                });
                return;
            }
            onAddReviewAttributeColumn(attributeColumnId);
            return;
        }
        if (isReviewAttributeAlreadySynced && isAtDefaultReviewAttributeIndex) {
            return;
        }
        // First-time record (no stored config): enforce default position before explanation.
        onAddReviewAttributeColumn(attributeColumnId);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        actions,
        areTaskViewQueryParamsReady,
        attributeColumnId,
        dynamicTableColumns.columnsOrder,
        hadStoredConfigOnLoad,
        onAddReviewAttributeColumn,
        reviewAttribute,
    ]);
    const { products, isLoading, isPageRowsSyncing, arePageRowsIncomplete, paginationModel, onPaginationModelChange, error, chunkLoadErrorProductCount, canRetryChunkLoad, retryChunkLoad, totalCount, refetchProductList, lastVariables, } = (0, hooks_1.useTaskProductList)({
        attributeColumnId,
        labelsSelection: dynamicTableColumns,
    });
    const productIds = (0, react_1.useMemo)(() => products.map(({ id }) => id), [products]);
    // Bridges the columns -> parsed rows -> stable rows hook-order cycle; displayed row state remains owned by useStableRowsDuringEdit.
    const patchDisplayedRowRef = (0, react_1.useRef)(() => undefined);
    const { productIdForDetailsModal, setProductIdForDetailsModal, productDetailsModalProps, } = (0, products_table_1.useProductDetailsModal)({
        productIds,
    });
    const extractedProductTreeNode = (0, react_1.useMemo)(() => { var _a; return (_a = products.find(({ id }) => id === productIdForDetailsModal)) === null || _a === void 0 ? void 0 : _a.productTreeNodeId; }, [productIdForDetailsModal, products]);
    const { processRowUpdate, isCellLoading, isCellSynced, isCellFailed, processRowUpdateError, } = (0, hooks_2.useProcessRowUpdate)({
        failedCellResetKey: products,
        tableFilter,
        tableSort,
        refetchProductList,
        selectedTreeNodePath,
    });
    const isRowDisabled = (0, react_1.useCallback)((row) => Boolean(row.isLocked), []);
    const { onCellSubmit, onCellEditStart: onSubmittedCellEditStart, isCellAutoOpen } = (0, product_table_1.useSubmittedCells)();
    const { productsReviewed, taskCount, scheduleProgressRefresh, refetchTaskProgress, isLoading: isTaskProgressLoading, } = (0, use_task_progress_hook_1.useTaskProgress)({
        nodeTitle,
        attributeName: attributeName !== null && attributeName !== void 0 ? attributeName : '',
    });
    const scheduleReviewStatusRefresh = (0, hooks_1.useReviewStatusFilteredProductsRefetch)({
        tableFilter,
        refetchProductList,
        scheduleProgressRefresh,
    });
    const patchReviewStatusRow = (0, react_1.useCallback)((rowId, patch) => {
        patchDisplayedRowRef.current(rowId, patch);
    }, []);
    const handleReviewStatusChange = (0, use_review_status_change_hook_1.useReviewStatusChange)({
        patchDisplayedRow: patchReviewStatusRow,
        scheduleReviewStatusRefresh,
    });
    const { tableColumns: { columns, isLoading: areColumnsLoading, selection: { excludedColumns, selectAllMode: selectAllColumnsMode, filterOptions, }, order: { columnsOrder, }, actions: { onChangeColumns, setOrder, }, }, } = (0, use_task_products_table_config_hook_1.useTaskProductsTableConfig)({
        onActiveProductIdChange: setProductIdForDetailsModal,
        dynamicTableColumns: customizeTableColumnsReturnValue,
        isCellLoading,
        isCellSynced,
        isCellFailed,
        isRowDisabled,
        onReviewStatusChange: handleReviewStatusChange,
        isCellAutoOpen,
        onCellSubmit,
    });
    const columnFieldsKey = JSON.stringify(columns.map(({ field }) => field));
    const { originalAttributeColumnIds, strategyAttributeLabels, } = (0, react_1.useMemo)(() => {
        const columnFields = JSON.parse(columnFieldsKey);
        return {
            originalAttributeColumnIds: (0, utils_1.getOriginalAttributeColumnIdsFromFields)(columnFields),
            strategyAttributeLabels: (0, utils_1.getStrategyAttributeLabelsFromFields)(columnFields),
        };
    }, [columnFieldsKey]);
    const sortColumn = (0, react_1.useMemo)(() => (tableSort ? { key: tableSort.key, direction: tableSort.direction } : undefined), [tableSort]);
    const parsedProducts = (0, react_1.useMemo)(() => ((0, utils_1.convertProductToDataGridRow)(products, originalAttributeColumnIds, strategyAttributeLabels, sortColumn)), [
        originalAttributeColumnIds,
        products,
        sortColumn,
        strategyAttributeLabels,
    ]);
    const dataGridLoadingState = (0, use_table_loading_state_1.useTableLoadingState)({
        requestVariables: lastVariables,
        isLoading: isLoading || areColumnsLoading || isBulkProductListRefreshing,
        hasError: Boolean(error),
    });
    const { displayedRows, handleCellEditStart, handleCellEditStop, patchDisplayedRow, stabilizedProcessRowUpdate, } = (0, product_table_1.useStableRowsDuringEdit)({
        rows: parsedProducts,
        processRowUpdate,
        onCellEditStart: onSubmittedCellEditStart,
        shouldHoldDisplayedRows: dataGridLoadingState.loading,
    });
    patchDisplayedRowRef.current = patchDisplayedRow;
    // Filtering
    const handleUpdateFilter = (0, react_1.useCallback)((model) => {
        var _a;
        if (areColumnsLoading)
            return;
        const tableFilter = (0, table_filter_1.buildFilterStateFromUIDataGridFilter)(model);
        dispatch((0, actions_1.setTaskViewTableFilter)(selectedCatalogId, tableFilter));
        dispatch((0, actions_1.setTaskViewTableSearch)(selectedCatalogId, (_a = model.quickFilterValues) === null || _a === void 0 ? void 0 : _a.join(' ')));
    }, [dispatch, selectedCatalogId, areColumnsLoading]);
    const persistedFilterData = (0, react_1.useMemo)(() => ({
        filter: !areColumnsLoading ? (0, table_filter_1.parseTableFilterStateToDataGridFilter)(tableFilter) : { quickFilterValues: [], items: [] },
    }), [tableFilter, areColumnsLoading]);
    const { filterModel, setFilterModel, } = (0, ui_components_1.useFilter)({
        persistedState: persistedFilterData.filter,
        setPersistedState: handleUpdateFilter,
    });
    const persistedSortData = (0, react_1.useMemo)(() => ({
        sort: !areColumnsLoading ? (0, table_sort_1.parseDataGridSortState)(tableSort) : [],
    }), [areColumnsLoading, tableSort]);
    // Sorting
    const handleUpdateSort = (0, react_1.useCallback)((model) => {
        if (areColumnsLoading)
            return;
        const newTableSort = (0, table_sort_1.buildSortStateFromUIDataGridSort)(model);
        const nextTableSort = newTableSort || reducers_1.defaultTaskViewTableState.sort;
        // If column is not visible DataGrid triggers onSortModelChange with empty sort model
        if (!(0, ramda_1.equals)(nextTableSort, tableSort) || !newTableSort) {
            dispatch((0, actions_1.setTaskViewTableSort)(selectedCatalogId, nextTableSort));
        }
    }, [dispatch, selectedCatalogId, tableSort, areColumnsLoading]);
    const { sortModel, setSortModel, } = (0, ui_components_1.useSorting)({
        persistedState: persistedSortData.sort,
        setPersistedState: handleUpdateSort,
    });
    const { columns: mergedColumns, onColumnResize } = (0, ui_components_1.useColumnWidth)({
        columns,
        persistedState: columnWidths,
        setPersistedState: (next) => {
            dispatch((0, actions_1.setTaskViewTableColumnWidth)(selectedCatalogId, next));
        },
    });
    const selection = (0, ui_components_1.useAdvancedSelection)({
        totalCount,
    });
    const { selectionModel, setSelectionModel, resetSelection, selectMultiple, isAllSelected, selectAllMode, excludedItemsIds, areAllItemsSelected, selectedItemsCount, isAtLeastOneItemSelected, } = selection;
    const { handleSelectAll } = (0, ui_components_1.useSelectionWithDisabledRows)(Object.assign(Object.assign({}, selection), { unselectableIds: parsedProducts.filter(({ isLocked }) => isLocked).map(({ id }) => id) }));
    const selectCurrentPage = (0, react_1.useCallback)(() => selectMultiple(productIds), [selectMultiple, productIds]);
    const isCurrentPageSelected = (0, react_1.useMemo)(() => isAllSelected(productIds), [isAllSelected, productIds]);
    const reviewAttributeType = (0, react_1.useMemo)(() => (attributeName === attributes_1.CustomProductAttributes.ClassificationProductType
        ? graphql_1.ProductAttributeType.Category
        : graphql_1.ProductAttributeType.Label), [attributeName]);
    const reviewStatus = (0, react_1.useMemo)(() => (attributeName ? { attribute: attributeName, attributeType: reviewAttributeType } : undefined), [attributeName, reviewAttributeType]);
    const { isBulkEditModalOpen, setBulkEditModalOpen, bulkEditModalProps, } = (0, products_table_1.useBulkEditProductsModal)({
        onBulkEditComplete: resetSelection,
        selectAllMode,
        tableSearch,
        excludedItemsIds: excludedItemsIds,
        tableFilter,
        productTreeNode,
        hasLockedProducts: parsedProducts.some((p) => p.isLocked),
        reviewAttribute,
        reviewStatus,
    });
    const handleBulkEdit = (columnField) => {
        var _a;
        // Type guard: only use columnField if it's a string (from column menu)
        // React may pass a synthetic event as first argument from onClick handlers
        const fieldFromColumnMenu = typeof columnField === 'string' ? columnField : undefined;
        const sourceId = fieldFromColumnMenu !== null && fieldFromColumnMenu !== void 0 ? fieldFromColumnMenu : reviewAttribute === null || reviewAttribute === void 0 ? void 0 : reviewAttribute.id;
        setEditInitialAttributeId(sourceId ? (_a = (0, table_columns_1.parseColumnId)(sourceId)) === null || _a === void 0 ? void 0 : _a.label : undefined);
        setBulkEditModalOpen(true);
    };
    const bulkReviewFilter = (0, products_table_1.useBulkActionsFilter)({
        selectAllMode,
        tableSearch,
        excludedItemsIds: excludedItemsIds,
        tableFilter,
        productTreeNode,
        hasLockedProducts: parsedProducts.some((p) => p.isLocked),
        includeAttributeStatuses: false,
        reviewStatus,
    });
    const { bulkReviewProductAttributes } = (0, product_1.useBulkReviewProductAttributes)();
    const handleMarkAsReviewed = (0, react_1.useCallback)(() => __awaiter(void 0, void 0, void 0, function* () {
        if (!attributeName)
            return;
        setIsBulkProductListRefreshing(true);
        try {
            const result = yield bulkReviewProductAttributes({
                attribute: attributeName,
                attributeType: reviewAttributeType,
                catalogId: selectedCatalogId,
                filter: bulkReviewFilter.product,
                presentationAttributes: bulkReviewFilter.presentationAttributes,
                presentationAttributeFilterStrategy: bulkReviewFilter.presentationAttributeFilterStrategy,
                isReviewed: bulkReviewFilter.isReviewed,
                expectedMatchedProductCount: selectAllMode ? selectedItemsCount : undefined,
                productTreeNodeId: productTreeNode.id,
                status: graphql_1.ProductAttributeReviewStatus.Reviewed,
            });
            if (!(result === null || result === void 0 ? void 0 : result.success)) {
                addError(t({ key: 'GENERAL_ERROR_MESSAGE' }));
                return;
            }
            yield refetchProductList();
            resetSelection();
            addSuccess(t({ key: 'BULK_REVIEW_SUCCESS_MESSAGE', values: { count: result.affectedCount } }));
            yield refetchTaskProgress();
        }
        catch (error) {
            addError(error instanceof Error ? error.message : t({ key: 'GENERAL_ERROR_MESSAGE' }));
        }
        finally {
            setIsBulkProductListRefreshing(false);
        }
    }), [
        attributeName,
        bulkReviewProductAttributes,
        reviewAttributeType,
        selectedCatalogId,
        bulkReviewFilter,
        selectAllMode,
        selectedItemsCount,
        productTreeNode.id,
        refetchProductList,
        resetSelection,
        refetchTaskProgress,
        addSuccess,
        t,
        addError,
    ]);
    const isSidebarOpen = (0, selectors_1.useTaskViewProductsTableIsSidebarOpen)();
    const toggleSidebar = (0, react_1.useCallback)(() => {
        dispatch((0, actions_1.setTaskViewSidebarOpen)(selectedCatalogId, !isSidebarOpen));
    }, [dispatch, isSidebarOpen, selectedCatalogId]);
    const pageRowsLoadStatus = (0, react_1.useMemo)(() => ({
        isSyncing: isPageRowsSyncing,
        failedProductCount: chunkLoadErrorProductCount,
        canRetry: canRetryChunkLoad,
        onRetry: retryChunkLoad,
    }), [
        canRetryChunkLoad,
        chunkLoadErrorProductCount,
        isPageRowsSyncing,
        retryChunkLoad,
    ]);
    return (react_1.default.createElement(products_table_styles_1.StyledProductsTableContainer, null, react_1.default.createElement(products_action_panel_1.ProductsActionPanel, { isSidebarOpen: isSidebarOpen, toggleSidebar: toggleSidebar, rowSize: tableRowSize, onChangeRowSize: toggleRowSize, totalCount: totalCount, isAtLeastOneProductSelected: isAtLeastOneItemSelected, onSelectCurrentPage: selectCurrentPage, selectedItemsCount: selectedItemsCount, onEdit: handleBulkEdit, onSettingsClick: () => setIsCustomizeViewOpen(true), onResetSelectedProducts: resetSelection, isCurrentPageSelected: isCurrentPageSelected, onSelectAllProducts: handleSelectAll, areAllProductsSelected: areAllItemsSelected, onMarkAsReviewed: handleMarkAsReviewed, taskProgress: { productsReviewed, taskCount, isLoading: isTaskProgressLoading }, dynamicColumns: dynamicTableColumns, productTreeNodeId: productTreeNode.id, reviewStatus: reviewStatus }), areTaskViewQueryParamsReady && (react_1.default.createElement(product_table_1.ProductTable, { columns: mergedColumns, onColumnResize: onColumnResize, pinnedColumns: persistedTableData.pinnedColumns, onPinnedColumnsChange: onPinnedColumnsChange, rows: displayedRows, loading: dataGridLoadingState.loading, error: error === null || error === void 0 ? void 0 : error.message, pageRowsLoadStatus: pageRowsLoadStatus,
        // Keep the current rows visible and show a progress bar under the header when reloading
        // due to filter/sort/search changes, instead of replacing rows with a skeleton. The
        // skeleton is still used for the initial load, when there are no rows yet (noRowsVariant).
        // Only `loadingOverlay` is overridden here; the cast avoids re-declaring the other required
        // slot prop overrides, which ProductTable already provides internally.
        slotProps: {
            loadingOverlay: {
                variant: 'linear-progress',
                noRowsVariant: 'skeleton',
            },
        }, rowCount: totalCount, filterModel: filterModel, onFilterModelChange: setFilterModel, sortModel: sortModel, onSortModelChange: setSortModel, paginationModel: paginationModel, onPaginationModelChange: onPaginationModelChange, rowSelectionModel: selectionModel, onRowSelectionModelChange: setSelectionModel, isHeaderSelectionDisabled: arePageRowsIncomplete, pageSizeOptions: client_constants_1.PAGE_SIZES, onEditAttribute: handleBulkEdit, hasSelection: isAtLeastOneItemSelected, tableRowSize: tableRowSize, processRowUpdate: stabilizedProcessRowUpdate, onProcessRowUpdateError: processRowUpdateError, isRowDisabled: isRowDisabled, onCellEditStart: handleCellEditStart, onCellEditStop: handleCellEditStop, enableMultiFiltering: enableMultiFiltering, columnsOrder: columnsOrder, onColumnOrderChange: setOrder })), isBulkEditModalOpen && (react_1.default.createElement(bulk_edit_product_attributes_dialog_1.BulkEditProductAttributesDialog, Object.assign(Object.assign({ selectedTreeNodeId: productTreeNode === null || productTreeNode === void 0 ? void 0 : productTreeNode.id }, bulkEditModalProps), { initialAttributeId: editInitialAttributeId, selectedProductsCount: selectedItemsCount, expectedMatchedProductCount: selectAllMode ? selectedItemsCount : undefined, onProductListRefreshStateChange: setIsBulkProductListRefreshing }))), !!productIdForDetailsModal && (react_1.default.createElement(product_details_dialog_component_1.ProductDetailsDialog, Object.assign(Object.assign({}, productDetailsModalProps), { productTreeNodeId: extractedProductTreeNode }))), isCustomizeViewOpen && (react_1.default.createElement(products_customize_view_1.ProductCustomizeViewContainer, { productTreeNodeId: productTreeNode.id, excludedColumns: excludedColumns, columnsOrder: columnsOrder, selectAllMode: selectAllColumnsMode, filterOptions: filterOptions, onChangeColumns: onChangeColumns, onClose: () => setIsCustomizeViewOpen(false) }))));
};
exports.TaskProductsTable = TaskProductsTable;
